import React from "react";

function About() {
    return (
        <div className="container-fluid" style={{ backgroundColor: '#054161e5' }}>
            <section className="showcase f text-white p-5">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <h1 className="text-center">About Us</h1>
                            <p className="lead text-center text-white">
                                SkyMy Travel
                            </p>
                            <div className="text-center mt-4 p-5">
                                <h4>Follow Us On Social Media</h4>
                                <div className="social">
                                    <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                                        <i className="bi bi-twitter"></i>
                                    </a>
                                    <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer">
                                        <i className="bi bi-facebook"></i>
                                    </a>
                                    <a href="https://github.com/" target="_blank" rel="noopener noreferrer">
                                        <i className="bi bi-github"></i>
                                    </a>
                                    <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                                        <i className="bi bi-linkedin"></i>
                                    </a>
                                </div>
                            </div>
                            <div className="p-5"></div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default About;
